import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import autograph from './autograph'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(function(config) {
  

  const data = autograph(config.url, config.data)
  config.data = data.encryParam
  config.headers = data.headers
  return config
}, error => {
  // Do something with request error

  Promise.reject(error)
})
// function messageBox(val) {
//   MessageBox.confirm(val, '确定登出', {
//     confirmButtonText: '重新登录',
//     cancelButtonText: '取消',
//     type: 'warning'
//   }).then(() => {
//     store.dispatch('user/logout').then(() => {
//       location.reload()// 为了重新实例化vue-router对象 避免bug
//     })
//   }).catch(() => {
//     store.dispatch('user/logout').then(() => {
//       location.reload()// 为了重新实例化vue-router对象 避免bug
//     })
//   })
// }

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * ServerNo为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
   
    //取消loading
    store.dispatch('user/setLoading', false);
    
    if (res === null) {
      MessageBox.confirm('账号异地登录,请重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      }).catch(() => {
        store.dispatch('user/logout').then(() => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      })
    }
    if (res.ServerNo !== 200) {
      switch (res.ServerNo) {
        case 400:
          Message({
            showClose: true,
            title: '消息提示',
            message: res.ResultData,
            type: 'warning',
            duration: 5 * 1000
          })
          break
        case 401: 
        
        var str = '<div><strong>'+ res.ResultData.content +'</strong><div>'
        str += "<div><span>联系电话：</span>"+ res.ResultData.mobile +"</div>"
          MessageBox.alert(str , res.ResultData.title, {
            dangerouslyUseHTMLString: true
          });
        case 'SN001':
          messageBox('服务器内部报错,请重新登录')
          break
        case 'SN002':
          MessageBox.confirm('时间超时,请检查时间', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/logout').then(() => {
              location.reload()// 为了重新实例化vue-router对象 避免bug
            })
          }).catch(() => {
          })
        break
        case 'SN003':
          messageBox('Version number exception,请重新登录')
          break
        case 'SN004':
          messageBox('Global user ID can not be null,请重新登录')
          break
        case 'SN005':
          messageBox('签名错误,请重新登录')
          break
        case 'SN006':
          messageBox('No access,请重新登录')
          break
        case 'SN007':
          messageBox('user not,登录token过期,请重启登录')
          break
        case 'SN008':
          messageBox('Other devices login,请重新登录')
          break
        case 'SN009':
          messageBox('oken time out,请重新登录')
          break
        case 'SN0010':
          messageBox('Permission denied,请重新登录')
          break
        case '505':
            messageBox('该账号已过期，请联系客服')
            break
        default:
          MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/logout').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
      }
      //抛出报错信息
      return Promise.reject(res)
    } else {
      return res.ResultData
    }
  },
  error => {
    Message({
      showClose: true,
      title: '消息提示',
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
